import { defineMessages } from 'react-intl';

export default defineMessages({    
    additionalNamedInsureds:{
        id:'quoteandbind.ba.policy-details.Additional Named Insureds',
        defaultMessage: 'Additional Named Insureds'
    },
    additionalNamedInsured:{
        id:'quoteandbind.ba.policy-details.Additional Named Insured',
        defaultMessage: 'Additional Named Insured'
    },
    additionalNamedInsuredsName:{
        id:'quoteandbind.ba.policy-details.Name',
        defaultMessage: 'Name'
    },
    additionalNamedInsuredsRelation:{
        id:'quoteandbind.ba.policy-details.Relationship To Primary Named Insured',
        defaultMessage: 'Relationship To Primary Named Insured'
    },
    addAnotherAdditionNamesInsured:{
        id:'quoteandbind.ba.policy-details.Add Another Additional Named Insured?',
        defaultMessage: 'Add Another Additional Named Insured?'
    },
    primaryNamedInsured:{
        id: "quoteandbind.ba.policy-details.PolicyPriNamedInsured",
        defaultMessage: "Primary Named Insured"
    },
    policyAddress:{
        id: "quoteandbind.ba.policy-details.Policy Address",
        defaultMessage: "Policy Address"
    },
    changePrimaryNamedInsured: {
        id: "quoteandbind.ba.policy-details.ChangePriNamedInsured",
        defaultMessage: "Change Primary Named Insured"
    },
    changePolicyAddress: {
        id: "quoteandbind.ba.policy-details.Change Policy Address",
        defaultMessage: "Change Policy Address"
    },
    minimumDateError:{
        id: "quoteandbind.ba.policy-details.Coverage Start date cannot be prior to",
        defaultMessage:"Coverage Start date cannot be prior to"
    },
    baExpiryDate:{
        id: "quoteandbind.ba.policy-info.Expiration Date",
        defaultMessage:"Expiration Date"
    },
    baTermType:{
        id: "quoteandbind.ba.policy-info.Term Type",
        defaultMessage:"Term Type"
    },
    baPriorPolInf:{
        id: "quoteandbind.ba.policy-info.Prior Policy Information",
        defaultMessage:"Prior Policy Information"
    },
    baPriorCarName:{
        id: "quoteandbind.ba.policy-info.Prior Carrier Name",
        defaultMessage:"Prior Carrier Name"
    },
    baPriorPolNum:{
        id: "quoteandbind.ba.policy-info.Prior Policy #",
        defaultMessage:"Prior Policy #"
    },
    baPriorPolExp:{
        id: "quoteandbind.ba.policy-info.Prior Expiration Date",
        defaultMessage:"Prior Expiration Date"
    },
    baPriorPolYears:{
        id: "quoteandbind.ba.policy-info.Number of Years with Prior Carrier",
        defaultMessage:"Number of Years with Prior Carrier"
    },
    baPriorPolCanc:{
        id: "quoteandbind.ba.policy-info.Have you been cancelled by an insurance company in the last 3 years",
        defaultMessage:"Have you been cancelled by an insurance company in the last 3 years"
    },
    bmsClientCode: {
        id: "quoteandbind.ba.policy-info.BMS Client Code",
        defaultMessage: "BMS Client Code"
      }
});
